import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 * @property {HTMLButtonElement} videoPlayButton - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement', 'videoPlayButton'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement, videoPlayButton } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      if (videoSource) source.setAttribute('src', videoSource);
    }

    videoElement.load();

    videoPlayButton.addEventListener('click', () => {
      if (videoElement.paused) {
        videoPlayButton.classList.add('video-playing');
        videoElement.play();
        return;
      }

      videoPlayButton.classList.remove('video-playing');
      videoElement.pause();
    });
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}

